<script lang="ts">
import "@cisco-u/icons/icons/cu-icon-chevron-right.js";

import { defineComponent } from "vue";

export default defineComponent({
  emits: ["next-slide", "back-slide", "hideGenAIModel", "handleSubmitButton"],
  props: {
    currentSlideNumber: {
      type: Number,
      default: 0,
    },
    showNext: {
      type: Boolean,
      default: false,
    },
    allowNextNav: {
      type: Boolean,
      default: false,
    },
    showPrevious: {
      type: Boolean,
      default: false,
    },
    exitBtn: {
      type: Boolean,
      default: false,
    },
    submitButton: {
      type: Boolean,
      default: false,
    },
    nextSlideText: {
      type: String,
      default: "Next",
    },
  },
});
</script>

<template>
  <div v-if="currentSlideNumber != undefined">
    <div
      class="case-slider__navigation flex w-full flex-row-reverse justify-between xsmobile:flex-col-reverse xsmobile:items-center"
    >
      <div class="next" v-if="showNext && !exitBtn">
        <button
          data-cy="nextButton"
          :class="[
            'btn inline-flex px-4 items-center text-white-lightest',
            allowNextNav
              ? 'bg-blue-light'
              : 'bg-[#0076D54D] border-0 text-[#0076D5]',
          ]"
          @click="$emit('next-slide')"
          @keyup.enter="$emit('next-slide')"
          @keyup.space="$emit('next-slide')"
          :disabled="!allowNextNav"
        >
          <span v-if="!exitBtn" class="flex items-center">
            <span class="block pr-2.5 text-white-lightest">{{
              nextSlideText
            }}</span>
            <cu-icon-chevron-right></cu-icon-chevron-right>
          </span>
        </button>
      </div>

      <div class="submt" v-if="submitButton">
        <button
          data-cy="submitBtn"
          class="btn px-4 inline-flex bg-blue-light items-center text-white-lightest bg-blue-light"
          @click="$emit('handleSubmitButton')"
          @keyup.enter="$emit('handleSubmitButton')"
          @keyup.space="$emit('handleSubmitButton')"
        >
          <span class="flex items-center">
            <span class="block pr-2.5 text-white-lightest font-normal"
              >Let’s do this!</span
            >
            <cu-icon-chevron-right></cu-icon-chevron-right>
          </span>
        </button>
      </div>

      <div class="exit" v-if="exitBtn">
        <button
          data-cy="exitBtn"
          class="btn inline-flex items-center text-white-lightest bg-blue-light hover:shadow-lg"
          @click="$emit('hideGenAIModel')"
          @keyup.enter="$emit('hideGenAIModel')"
          @keyup.space="$emit('hideGenAIModel')"
          :disabled="!allowNextNav"
        >
          <span class="flex items-center">
            <span class="block text-white-lightest">Finish</span>
          </span>
        </button>
      </div>

      <div class="prev" v-if="showPrevious">
        <button
          data-cy="backButton"
          class="btn inline-flex items-center bg-transparent hover:bg-black hover:text-white-lightest"
          @click="$emit('back-slide')"
          @keyup.enter="$emit('back-slide')"
          @keyup.space="$emit('back-slide')"
        >
          Back
        </button>
      </div>
    </div>

    <div
      class="swiper-pagination-bullets swiper-pagination-horizontal relative -top-[4.6875rem] mt-[1.25rem] flex flex-row justify-center pt-px"
    >
      <span
        v-for="slide in 4"
        :key="slide"
        class="swiper-pagination-bullet"
        :class="{
          'bg-blue-light opacity-100': currentSlideNumber === slide,
        }"
      />
    </div>
  </div>
</template>

<style scoped>
.swiper-pagination-bullet {
  width: 8px !important;
  height: 8px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
}
</style>
